import { createApi } from "@reduxjs/toolkit/query/react";
import { prepareBaseQuery } from "./baseQueryWithReauth";

const aiEmailsApi = createApi({
  reducerPath: "admin-ai-emails",
  baseQuery: prepareBaseQuery("/admin-ai/"),
  tagTypes: ["AdminAIPresets"],
  endpoints: (builder) => ({
    getPresets: builder.query({
      query: () => ({
        url: "presets",
        method: "GET",
      }),
      providesTags: ["AdminAIPresets"],
    }),
    generateEmailDraft: builder.mutation({
      query: ({ eventId, goal, tone, length, extraContext, presetKey }) => ({
        url: "generate-email",
        method: "POST",
        body: {
          eventId,
          goal,
          ...(tone ? { tone } : {}),
          ...(length ? { length } : {}),
          ...(extraContext ? { extraContext } : {}),
          ...(presetKey ? { presetKey } : {}),
        },
      }),
    }),
    generateGmailThreadReplyDraft: builder.mutation({
      query: ({ goal, tone, length, extraContext, threadText }) => ({
        url: "gmail/thread-reply",
        method: "POST",
        body: {
          goal,
          threadText,
          ...(tone ? { tone } : {}),
          ...(length ? { length } : {}),
          ...(extraContext ? { extraContext } : {}),
        },
      }),
    }),
    generateEventGmailThreadReplyDraft: builder.mutation({
      query: ({
        eventId,
        goal,
        tone,
        length,
        extraContext,
        presetKey,
        threadText,
        includeServices,
        includePricing,
      }) => ({
        url: "gmail/event-thread-reply",
        method: "POST",
        body: {
          eventId,
          goal,
          threadText,
          ...(tone ? { tone } : {}),
          ...(length ? { length } : {}),
          ...(extraContext ? { extraContext } : {}),
          ...(presetKey ? { presetKey } : {}),
          ...(typeof includeServices === "boolean" ? { includeServices } : {}),
          ...(typeof includePricing === "boolean" ? { includePricing } : {}),
        },
      }),
    }),
  }),
});

export const {
  useGetPresetsQuery,
  useGenerateEmailDraftMutation,
  useGenerateGmailThreadReplyDraftMutation,
  useGenerateEventGmailThreadReplyDraftMutation,
} = aiEmailsApi;

export default aiEmailsApi;
